import React, { useEffect, useState } from 'react';
import axios from 'axios';
import backgroundImage from './img/back.jpg';
import './css/informasi.css';
import { Icon } from "@iconify/react";

const Bed = () => {
  const [bedData, setBedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [currentTime, setCurrentTime] = useState({
    hour: '',
    minute: '',
    second: ''
  });

  const tarifData = [
    { kelas: 'KELAS I', harga: 'Rp. 150.000,-' },
    { kelas: 'KELAS II', harga: 'Rp. 120.000,-' },
    { kelas: 'KELAS III', harga: 'Rp. 80.000,-' },
    { kelas: 'VIP', harga: 'Rp. 650.000,-' },
    { kelas: 'ISOLASI-PARU', harga: 'Rp. 193.750,-' },
  ];

  const getDayName = () => {
    const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
    return days[new Date().getDay()];
  };

  const getMonthName = () => {
    const months = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli",
      "Agustus", "September", "Oktober", "November", "Desember"
    ];
    return months[new Date().getMonth()];
  };

  const getCurrentDate = () => {
    const today = new Date();
    return `${getDayName()}, ${today.getDate()} ${getMonthName()} ${today.getFullYear()}`;
  };

  useEffect(() => {
    document.body.style.backgroundImage = `url(${backgroundImage})`;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.title = "Informasi Tempat Tidur";

    const interval = setInterval(() => {
      const now = new Date();
      setCurrentTime({
        hour: now.getHours().toString().padStart(2, '0'),
        minute: now.getMinutes().toString().padStart(2, '0'),
        second: now.getSeconds().toString().padStart(2, '0')
      });
    }, 1000);

    const scrollTopElement = document.getElementById('scroll-top');
    if (scrollTopElement) scrollTopElement.remove();

    return () => {
      document.body.style.backgroundImage = '';
      document.title = "RSUD H. ABDUL MANAP KOTA JAMBI";
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://simanap.rsudkotajambi.id:5000/api/bed');
        setBedData(response.data);
      } catch (err) {
        console.error(err);
        setError('Gagal mengambil data tempat tidur');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const cariData = (ruang, kelas = null) => {
    return bedData.find(item => item.ruang === ruang && (kelas ? item.kelas === kelas : true));
  };

  return (
    <header>
      <div className="container-fluid">
        <nav className="navbar mt-3" id="nav1">
          <h1>
            INFORMASI KETERSEDIAAN TEMPAT TIDUR <span>RSUD H. ABDUL MANAP</span>
          </h1>

          <div className="time-banner">
            <Icon icon="line-md:calendar" /> {getCurrentDate()} <br />
            <Icon icon="svg-spinners:clock" /> {currentTime.hour}:{currentTime.minute}:{currentTime.second}
          </div>
        </nav>
      </div>

      <div className="container-fluid text-center">
        {loading && <p className="text-primary">Memuat data tempat tidur...</p>}
        {error && <p className="text-danger">{error}</p>}

        <div className="row">
          <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">ANAK</h5>
                <div className="table-responsive">
                    <table className="table table-borderless table-sm text-dark text-center">
                        <thead>
                            <tr>
                            <th>KELAS</th>
                            <th>KAPASITAS</th>
                            <th>TERSEDIA</th>
                            <th>PRIA</th>
                            <th>WANITA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {["I", "II", "III"].map(kelas => {
                            const data = cariData("Anak", kelas);
                            return (
                                <tr key={kelas}>
                                <td>{kelas}</td>
                                <td>{data ? data.kapasitas : "-"}</td>
                                <td>{data ? data.tersedia : "-"}</td>
                                <td>{data ? data.tersediapria : "-"}</td>
                                <td>{data ? data.tersediawanita : "-"}</td>
                                </tr>
                            );
                            })}
                        </tbody>
                    </table>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">BEDAH</h5>
                <div className="table-responsive">
                    <table className="table table-borderless table-sm text-dark text-center">
                    <thead>
                        <tr>
                        <th>KELAS</th>
                        <th>KAPASITAS</th>
                        <th>TERSEDIA</th>
                        <th>PRIA</th>
                        <th>WANITA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {["I", "II", "III"].map(kelas => {
                        const data = cariData("Bedah", kelas);
                        return (
                            <tr key={kelas}>
                            <td>{kelas}</td>
                            <td>{data ? data.kapasitas : "-"}</td>
                            <td>{data ? data.tersedia : "-"}</td>
                            <td>{data ? data.tersediapria : "-"}</td>
                            <td>{data ? data.tersediawanita : "-"}</td>
                            </tr>
                        );
                        })}
                    </tbody>
                    </table>
                </div>
              </div>
            </div>
          </div>

        <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">PARU</h5>
                <div className="table-responsive">
                <table className="table table-borderless table-sm text-dark text-center">
                  <thead>
                    <tr>
                      <th>KELAS</th>
                      <th>KAPASITAS</th>
                      <th>TERSEDIA</th>
                      <th>PRIA</th>
                      <th>WANITA</th>
                    </tr>
                  </thead>
                  <tbody>
                    {["I", "II", "III"].map(kelas => {
                      const data = cariData("Paru", kelas);
                      return (
                        <tr key={kelas}>
                          <td>{kelas}</td>
                          <td>{data ? data.kapasitas : "-"}</td>
                          <td>{data ? data.tersedia : "-"}</td>
                          <td>{data ? data.tersediapria : "-"}</td>
                          <td>{data ? data.tersediawanita : "-"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>

        <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">MATA, THT, KULIT</h5>
                   <div className="table-responsive">
                    <table className="table table-borderless table-sm text-dark text-center">
                    <thead>
                        <tr>
                        <th>KELAS</th>
                        <th>KAPASITAS</th>
                        <th>TERSEDIA</th>
                        <th>PRIA</th>
                        <th>WANITA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {["I", "II", "III"].map(kelas => {
                        const data = cariData("Mata, Kulit, THT", kelas);
                        return (
                            <tr key={kelas}>
                            <td>{kelas}</td>
                            <td>{data ? data.kapasitas : "-"}</td>
                            <td>{data ? data.tersedia : "-"}</td>
                            <td>{data ? data.tersediapria : "-"}</td>
                            <td>{data ? data.tersediawanita : "-"}</td>
                            </tr>
                        );
                        })}
                    </tbody>
                    </table>
                   </div>
              </div>
            </div>
          </div>

        <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">JANTUNG</h5>
                   <div className="table-responsive">
                        <table className="table table-borderless table-sm text-dark text-center">
                    <thead>
                        <tr>
                        <th>KELAS</th>
                        <th>KAPASITAS</th>
                        <th>TERSEDIA</th>
                        <th>PRIA</th>
                        <th>WANITA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {["I", "II", "III"].map(kelas => {
                        const data = cariData("Jantung", kelas);
                        return (
                            <tr key={kelas}>
                            <td>{kelas}</td>
                            <td>{data ? data.kapasitas : "-"}</td>
                            <td>{data ? data.tersedia : "-"}</td>
                            <td>{data ? data.tersediapria : "-"}</td>
                            <td>{data ? data.tersediawanita : "-"}</td>
                            </tr>
                        );
                        })}
                    </tbody>
                    </table>
                   </div>
              </div>
            </div>
          </div>

          
        <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">PENYAKIT DALAM</h5>
                  <div className="table-responsive">
                    <table className="table table-borderless table-sm text-dark text-center">
                        <thead>
                            <tr>
                            <th>KELAS</th>
                            <th>KAPASITAS</th>
                            <th>TERSEDIA</th>
                            <th>PRIA</th>
                            <th>WANITA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {["I", "II", "III"].map(kelas => {
                            const data = cariData("Penyakit Dalam", kelas);
                            return (
                                <tr key={kelas}>
                                <td>{kelas}</td>
                                <td>{data ? data.kapasitas : "-"}</td>
                                <td>{data ? data.tersedia : "-"}</td>
                                <td>{data ? data.tersediapria : "-"}</td>
                                <td>{data ? data.tersediawanita : "-"}</td>
                                </tr>
                            );
                            })}
                        </tbody>
                        </table>
                  </div>
              </div>
            </div>
          </div>

        <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">RAWAT GABUNG</h5>
                 <div className="table-responsive">
                    <table className="table table-borderless table-sm text-dark text-center">
                        <thead>
                            <tr>
                            <th>KELAS</th>
                            <th>KAPASITAS</th>
                            <th>TERSEDIA</th>
                            <th>PRIA</th>
                            <th>WANITA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {["I", "II", "III"].map(kelas => {
                            const data = cariData("Rawat Gabung Kebidanan", kelas);
                            return (
                                <tr key={kelas}>
                                <td>{kelas}</td>
                                <td>{data ? data.kapasitas : "-"}</td>
                                <td>{data ? data.tersedia : "-"}</td>
                                <td>{data ? data.tersediapria : "-"}</td>
                                <td>{data ? data.tersediawanita : "-"}</td>
                                </tr>
                            );
                            })}
                        </tbody>
                        </table>
                    </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">VIP</h5>
                <table className="table table-borderless table-sm text-dark text-center">
                  <thead>
                    <tr>
                      <th>KAPASITAS</th>
                      <th>TERSEDIA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{cariData("VIP")?.kapasitas || "-"}</td>
                      <td>{cariData("VIP")?.tersedia || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">ISOLASI COVID-19</h5>
                <table className="table table-borderless table-sm text-dark text-center">
                  <thead>
                    <tr>
                      <th>KAPASITAS</th>
                      <th>TERSEDIA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{cariData("Isolasi Covid-19")?.kapasitas || "-"}</td>
                      <td>{cariData("Isolasi Covid-19")?.tersedia || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

           <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">ICU COVID-19</h5>
                <table className="table table-borderless table-sm text-dark text-center">
                  <thead>
                    <tr>
                      <th>KAPASITAS</th>
                      <th>TERSEDIA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{cariData("ICU Covid-19")?.kapasitas || "-"}</td>
                      <td>{cariData("ICU Covid-19")?.tersedia || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

           <div className="col-lg-3">
            <div className="card border-info mb-3">
              <div className="card-body text-dark">
                <h5 className="card-title">ICU</h5>
                <table className="table table-borderless table-sm text-dark text-center">
                  <thead>
                    <tr>
                      <th>KAPASITAS</th>
                      <th>TERSEDIA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{cariData("ICU")?.kapasitas || "-"}</td>
                      <td>{cariData("ICU")?.tersedia || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        <div className="col-lg-3">
  <div className="card border-danger mb-3">
    <div className="card-body text-dark">
      <h5 className="card-ruang text-danger fw-bold fs-4">TARIF</h5>
      <small className="text-danger fw-semibold">PERWAL NO 41 TAHUN 2019</small>
      <div className="marquee mt-3">
        <div className="marquee-content">
          {tarifData.map((item, index) => (
            <div className="row mb-2" key={index}>
              <div className="col-6">
                <p className="fw-bold fs-6 mb-0">{item.kelas}</p>
              </div>
              <div className="col-6">
                <p className="fw-bold fs-6 mb-0">{item.harga}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</div>


        </div>
      </div>
    </header>
  );
};

export default Bed;
